module.exports = __webpack_public_path__ + "static/media/metales.4a5d059d.png";